import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { spesa } from '@/model/qsadminapi/QsAdminApiModuleModel'

export const getMainDocumentPreview = async (data: spesa) => {
  const imagePreview = await useQsAdminApiManager
    .getState()
    .client.get(`/api/spesa/getimagespreview?expenseId=${data.id}&path=${data.mainDocumentUrl}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  window.open(imagePreview.data.images[0].sasToken, '_blank')
}
